$(function () {
	$('.product__slider').slick({
		slidesToShow: 1,
		initialSlide: 0,
		arrows: false,
		autoplay: true,
		adaptiveHeight: true,
		dots: true,
		appendDots: $('.product__productSlideDot'),
		prevArrow: '<div class="product__prevArrow"></div>',
		nextArrow: '<div class="product__nextArrow"></div>',
		appendArrows: $('.product__productSlide'),
		responsive: [{
			breakpoint: 481, //切り替えたいデバイス幅を入れる
			settings: {
				slidesToShow: 1,
			}
		}],
	});

	$('.sliderItem--reco').slick({
		slidesToShow: 5,
		arrows: false,
		dots: true,
		appendDots: $('.product__slideRecoDot'),
		prevArrow: '<div class="product__prevArrow"></div>',
		nextArrow: '<div class="product__nextArrow"></div>',
		appendArrows: $('.product__slideReco'),
		responsive: [{
			breakpoint: 480, //切り替えたいデバイス幅を入れる
			settings: {
				centerMode: true,
				slidesToShow: 1,
			}
		}],
	});

	$('.sliderItem--check').slick({
		slidesToShow: 5,
		arrows: false,
		dots: true,
		appendDots: $('.product__slideCheckDot'),
		prevArrow: '<div class="product__prevArrow"></div>',
		nextArrow: '<div class="product__nextArrow"></div>',
		appendArrows: $('.product__slideCheck'),
		responsive: [{
			breakpoint: 480, //切り替えたいデバイス幅を入れる
			settings: {
				centerMode: true,
				slidesToShow: 1,
			}
		}],
	});

	$('.productDetail__switchBtn').on('click', function () {
		$('.productDetail__switchBtn').removeClass('active');
		$(this).addClass('active');
		const btnNum = $(this).index();
		console.log(btnNum);
		$('.productDetail__textArea').removeClass('active');
		$('.productDetail__textArea').eq(btnNum).addClass('active');
	});

	//ハンバーガーメニュー内アコーディオン
	$('.headerNavi__listLink--acdn').on('click', function () {

		const isOpen = $(this).hasClass('open');

		$('.headerNavi__listLink--acdn').removeClass('open');
		$('.headerNavi__sub').removeClass('open');

		if (isOpen) {
			$(this).removeClass('open');
			$('.headerNavi__sub').removeClass('open');

		} else {
			$(this).next(".headerNavi__sub").addClass('open');
			$(this).addClass('open');
		}



	});

});
